<template>
    <div class="home_top_pic" v-if="imageUrl&&imageUrl.length>0">
        <a class="external" target="_blank" :href="link" v-if="link&&link.length>0">
            <img style="width: 100%;" :src="imageUrl" />
        </a>
        <img v-else style="width: 100%;" :src="imageUrl" />
    </div>
</template>

<script>
export default {
    name: "NavImage",
    props: {
        imageUrl: {
            type: String,
            default () {
                return ""
            }
        },
        link: {
            type: String,
            default () {
                return ""
            }
        }
    }
}
</script>